<template>
  <div class="modal-overflow">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label>Name</label>
              <el-input type="text"
                     name="name"
                     placeholder="Name"
                     v-validate="modelValidations.name"
                     v-model="edit.name"
                     @blur="ifNewCompanyValidateExistsInQuickbooks"
                     clearable />
              <small class="text-danger" v-show="errors.has('name')">
                {{ getError('name') }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Types</label>
              <el-select multiple name="types"
                         class="select"
                         size="large"
                         placeholder="Types"
                         v-validate="modelValidations.types"
                         data-vv-as="types"
                         v-model="edit.types">
                <el-option v-for="option in companyTypes"
                           class="select"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
              </el-select>
              <small class="text-danger" v-show="errors.has('types')">
                {{ getError('types') }}
              </small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label>Phone</label>
              <el-input type="text"
                     name="phone"
                     placeholder="Phone"
                     v-model="edit.phone"
                     clearable/>
              <small class="text-danger" v-show="errors.has('phone')">
                {{ getError('phone') }}
              </small>
            </div>
          </div>
          <div class="col-md-7">
            <label>Company Preferences</label>
            <div class="row" style="margin-top:12px;">
              <div class="col-md-4">
                <p-checkbox class="text-left" v-model="edit.useCreditCard">
                  Use Credit Card
                </p-checkbox>
              </div>
              <div class="col-md-4">
                <p-checkbox class="text-left" v-model="edit.poRequired">
                  P.O. Required
                </p-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div v-if="edit.useCreditCard" class="row">
          <div class="col-md-5"></div>
          <div class="col-md-7">
            <credit-card-check></credit-card-check>
          </div>
        </div>
        <hr />
        <div class="row" v-if="canEdit">
          <div class="col-md-5">
            <label>Company Logo - suggested 260px(w) x 100px(h)</label>
            <input @change="setFile"
                   accept=".jpg,.jpeg,.png"
                   type="file"
                   id="company-logo"
                   style="margin-top: 9px;" />
          </div>
          <div class="col-md-4" v-if="edit.logo">
            <label>Existing Logo / New Logo</label>
            <p-button title="Delete the existing company logo" :disabled="isDeleteDisabled" type="danger" size="sm" icon @click="clearLogo">
              <i class="fa fa-times"></i>
            </p-button>
            <span>
              {{ edit.logo.substr(0, 35) }}
            </span>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>PWS Number</label>
              <el-input type="text"
                        name="pwsNumber"
                        placeholder="PWS Number"
                        v-model="edit.pwsNumber"
                        clearable/>
              <small class="text-danger" v-show="errors.has('pwsNumber')">
                {{ getError('pwsNumber') }}
              </small>
            </div>
          </div>
        </div>
        <hr />
        <div class="department-notes">
          <h5 style="display: inline; color: #606266;">QUICKBOOKS</h5>
          <div class="row">
            <div class="col-md-5">
              <div style="margin-top: 10px;">
                <label>Preferences</label>
                <div class="row">
                  <div class="col-md-6">
                    <p-checkbox class="text-left" v-model="edit.quickBooksPreferences.toBePrinted">
                      To Be Printed
                    </p-checkbox>
                    <p-checkbox class="text-left" v-model="edit.quickBooksPreferences.toBeEmailed">
                      To Be Emailed
                    </p-checkbox>
                  </div>
                  <div class="col-md-6">
                    <p-checkbox class="text-left" v-model="edit.quickBooksPreferences.onHold">
                      On Hold
                    </p-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              <div style="margin-top: 10px;" v-if="qbShow">
                <label>Status</label>
                <img :src="'static/img/' + qbImage" style="margin-right: 5px;" width="20" height="20" ref="qbStatus">
                <span v-if="qbVerifying">Verifying that <strong>{{edit.name}}</strong> exists in QuickBooks. Please wait (approx 10 - 15 seconds).</span>
                <span v-html="qbMessage"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="department-notes">
              <h5 style="display: inline; color: #606266;">ADMIN NOTES</h5>
              <div class="pull-right" style="margin-top: -15px;">
                <button type="button" @click="editAdminNote" class="btn btn-fill btn-info el-icon-edit" style="padding: 8px;"></button>
              </div>
              <tabs value="Description" ref="adminNotesTabs">
                <tab-pane v-for="department in departments" :title="`${department.name}${checkForAdminNotes(department.id)}`" :key="department.id">
                  <p v-html="edit.notesByDepartment[department.id]"></p>
                </tab-pane>
              </tabs>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div style="margin-top: 12px;" class="department-notes">
              <h5 style="display: inline; color: #606266;">FIELD NOTES</h5>
              <div class="pull-right" style="margin-top: -15px;">
                <button type="button" @click="editFieldNote" class="btn btn-fill btn-info el-icon-edit" style="padding: 8px;"></button>
              </div>
              <tabs value="Description" ref="fieldNotesTabs">
                <tab-pane v-for="department in departments" :title="`${department.name}${checkForFieldNotes(department.id)}`" :key="department.id">
                  <p v-html="edit.fieldNotesByDepartment[department.id]"></p>
                </tab-pane>
              </tabs>
            </div>
          </div>
        </div>
        <div class="row card-body">
          <addresses></addresses>
        </div>
        <div class="row card-body" style="margin-top: -20px;">
          <contacts></contacts>
        </div>
        <div class="row" style="margin-top: 15px" v-if="canEdit">
          <div class="col-md-12">
            <button type="submit" :disabled="isProcessing" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
            <div class="form-group form-group-active-label">
              <label class="active-label">Active</label>
              <p-switch v-model="edit.active" type="primary" on-text="YES" off-text="NO"></p-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Autocomplete} from 'element-ui'
  import {mapGetters} from 'vuex'
  import {
    notifySuccess,
    notifyWarning,
    notifyError,
    objectBy,
    objectByName,
    noteIconSlice,
    objectById,
    sleepOneSecond
  } from 'src/utilities/utils'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import CreditCardCheck from './CreditCardCheck.vue'
  import Constants from 'src/utilities/constants'
  import Permissions from 'src/utilities/permissions'
  import Addresses from './Addresses.vue'
  import Contacts from './Contacts.vue'
  import {Tabs, TabPane} from 'src/components/UIComponents'
  import {sync} from 'vuex-pathify'
  import {OK, ACCEPTED, NOT_ACCEPTABLE, INTERNAL_SERVER_ERROR, UNAUTHORIZED, CREATED} from 'http-status-codes'
  import _ from 'lodash'

  export default {
    props: ['data'],
    components: {
      Addresses,
      Contacts,
      CreditCardCheck,
      PSwitch,
      [Autocomplete.name]: Autocomplete,
      TabPane,
      Tabs
    },
    computed: {
      edit: sync('companies@edit'),
      ...mapGetters({
        companyTypes: 'types/company',
        statuses: 'statuses/company',
        departments: 'departments/allExceptInformationTechnology',
        user: 'security/user'
      }),
      canEdit() {
        return this.$can('edit', Permissions.COMPANIES)
      },
      isDeleteDisabled() {
        if (!this.$store.get('companies@edit.logo')) {
          return true
        }
      }
    },
    data() {
      return {
        isProcessing: false,
        qbShow: false,
        qbVerifying: true,
        qbImage: 'loading-2.gif',
        qbMessage: '',
        constants: Constants,
        toDelete: null,
        fieldTypeForCreateOnTheFly: null,
        saved: false,
        originalCompanyName: null,
        modelValidations: {
          name: {
            required: true
          },
          phone: {
            required: false
          },
          types: {
            required: true
          }
        }
      }
    },
    methods: {
      isEditing() {
        return this.data && (this.data._id || this.data.id)
      },
      checkForAdminNotes(departmentId) {
        if (this.edit.notesByDepartment[departmentId]) {
          return ' ★'
        }
        return ''
      },
      checkForFieldNotes(departmentId) {
        if (this.edit.fieldNotesByDepartment[departmentId]) {
          return ' ★'
        }
        return ''
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      async validateAndSubmit() {
        // prevent multiple submits
        if (this.isProcessing) {
          return
        }

        this.isProcessing = true
        if (await this.$validator.validateAll()) {
          const savePayload = this.$store.get('companies/savePayload', 'companies')
          const response = await this.$store.dispatch('save2', savePayload)

          if (OK === response.status || CREATED === response.status) {
            if (this.fieldTypeForCreateOnTheFly && !_.includes(response.data.types, this.fieldTypeForCreateOnTheFly)) {
              // when adding company on-the-fly, only emitting companySaved if the company type matches the field type.
              notifyWarning(this, `Cannot set field. Company types does not include ${this.fieldTypeForCreateOnTheFly}`)
            } else {
              this.saved = true
              this.$eventHub.$emit('companySaved', response.data)
            }

            await this.maybeUploadLogo()
            notifySuccess(this, 'Company Saved Successfully')
            this.$store.commit('companies/resetEdit')
            this.$emit('close')
          } else if (UNAUTHORIZED === response.status) {
            const action = savePayload.id ? 'update' : 'create'
            notifyWarning(this, `You are not authorized to ${action} Companies`)
          } else {
            notifyError(this, 'Failed to Save Company ', response.errors)
            this.isProcessing = false
          }
        }
        this.isProcessing = false
      },
      clearLogo() {
        this.$store.set('companies/edit@logo', null)
        document.querySelector('#company-logo').value = null
        this.deleteLogo();
      },
      async deleteLogo() {
        const response = await this.$store.dispatch('files/delete', {
          path: Constants.FOLDERS.COMPANIES + '/' + this.originalCompanyName
        })

        if (NOT_ACCEPTABLE === response.status || INTERNAL_SERVER_ERROR === response.status) {
          notifyError(this, 'Error Deleting Logo')
        }
      },
      async maybeUploadLogo() {
        const files = document.querySelector('#company-logo').files

        if (files.length > 0) {
          const uploadResponse = await this.$store.dispatch('files/uploadCompanyFiles', {
            path: this.$store.get('companies/edit@name'),
            files: files
          })

          if (ACCEPTED !== uploadResponse.status) {
            notifyError('Failed to upload one or more user files.')
          }
        }
      },
      setFile() {
        const files = document.querySelector('#company-logo').files
        this.$store.set('companies/edit@logo', files[0].name)
      },
      maybeSetDefaultDepartment() {
        const defaultDepartment = objectById(this.departments, _.get(this.user, 'preferences.global.defaultDepartment'))
        if (defaultDepartment) {
          if (this.$refs.adminNotesTabs) {
            for (const tab of this.$refs.adminNotesTabs.tabs) {
              tab.active = tab._props.title === defaultDepartment.name || tab._props.title === defaultDepartment.name + ' ★'
            }
          }

          if (this.$refs.fieldNotesTabs) {
            for (const tab of this.$refs.fieldNotesTabs.tabs) {
              tab.active = tab._props.title === defaultDepartment.name || tab._props.title === defaultDepartment.name + ' ★';
            }
          }
        }
      },
      getAdminNotesActiveDepartment() {
        const activeTab = objectBy(this.$refs.adminNotesTabs.tabs, 'active', true)
        let activeTabDepartment = activeTab._props.title
        if (!activeTab) {
          console.error('Unable to load active Admin Tab')
          return false
        }
        if (activeTabDepartment.includes('★')) {
          activeTabDepartment = noteIconSlice(activeTabDepartment)
        }
        return objectByName(this.departments, activeTabDepartment)
      },
      getFieldNotesActiveDepartment() {
        const activeTab = objectBy(this.$refs.fieldNotesTabs.tabs, 'active', true)
        let activeTabDepartment = activeTab._props.title
        if (!activeTab) {
          console.error('Unable to load active Field Tab')
          return false
        }
        if (activeTabDepartment.includes('★')) {
          activeTabDepartment = noteIconSlice(activeTabDepartment)
        }
        return objectByName(this.departments, activeTabDepartment)
      },
      editAdminNote() {
        const department = this.getAdminNotesActiveDepartment()
        if (department) {
          const data = {
            department,
            noteType: 'Admin',
            note: this.$store.get('companies/companyAdminNoteByDepartmentId', department.id)
          }
          this.$eventHub.$emit('show-modal-5', 'Company Note', data, '800px')
        }
      },
      editFieldNote() {
        const department = this.getFieldNotesActiveDepartment()
        if (department) {
          const data = {
            department,
            noteType: 'Field',
            note: this.$store.get('companies/companyFieldNoteByDepartmentId', department.id)
          }
          this.$eventHub.$emit('show-modal-5', 'Company Note', data, '800px')
        }
      },
      refreshNotes() {
        this.$forceUpdate()
      },
      ifNewCompanyValidateExistsInQuickbooks() {
        if (!this.isEditing()) {
          this.clientExistsInQuickBooks(this.$store.get('companies/edit@name'))
        }
      },
      async clientExistsInQuickBooks(clientName) {
        this.qbShow = true

        const response = await this.$store.dispatch('quickbooks/customerExists', clientName)

        let image = 'active-error.png'
        let msg = 'QuickBooks is offline'
        if (OK === response.status) {
          const customerExists = response.data
          if (customerExists.quickbooksOnline) {
            image = 'active-false.png'
            msg = `<strong>${clientName}</strong> does not exist in QuickBooks. Please add <strong>${clientName}</strong> as a customer prior to generating an invoice.`
            if (customerExists.exists) {
              image = 'active-true.png'
              msg = `<strong>${clientName}</strong> exists in QuickBooks`
            }
          }
        }

        this.qbImage = image
        this.qbMessage = msg
        this.qbVerifying = false
      }
    },
    beforeCreate() {
      this.$store.cache.dispatch('types/fetchByEntityType', 'Company')
      this.$store.cache.dispatch('statuses/fetchByEntityType', 'Company')
    },
    async beforeMount() {
      await this.$validator.reset()
      if (this.isEditing()) {
        const companyId = this.data._id || this.data.id
        const response = await this.$store.dispatch('fetchById', {
          endpoint: 'companies',
          id: companyId
        })

        if (OK !== response.status) {
          notifyError(this, "Failed to load company by ID: " + companyId)
          return
        }

        this.originalCompanyName = response.data.name
        this.$store.set('companies/hydrateEdit', response.data)
        await this.clientExistsInQuickBooks(response.data.name)
      }
      this.maybeSetDefaultDepartment()
      this.$eventHub.$on('companyNoteSaved', this.refreshNotes)
    },
    async mounted() {
      if ((!this.data || !this.data.id ) && this.edit.types && this.edit.types.length === 1) {
        // Only fires if the user is adding a company on-the-fly(type is prepopulated, but no other data)
        this.fieldTypeForCreateOnTheFly = this.edit.types[0]
      }
    },
    destroyed() {
      if (!this.saved) {
        this.$eventHub.$emit('noCompanySelected', this.fieldTypeForCreateOnTheFly)
      }
      this.$eventHub.$off('companyNoteSaved')
      this.$store.commit('companies/resetEdit')
    }
  }
</script>
<style scoped>
  label {
    display: block;
  }
  .company-container .card {
    box-shadow: none;
  }
  .department-notes {
    width: 100%;
    background-color: #f5f7fa;
    padding: 20px;
  }
</style>
